import { FirearmPoolSearchComponentBase } from './firearm-pool-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BUSINESS_UNIT_TYPE, BusinessUnit } from 'assets-model';
import { AssetsUserDetailsService, FirearmPoolService, FirearmService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-firearm-pool-search',
  templateUrl: './firearm-pool-search.component.html',
  styleUrls: ['./firearm-pool-search.component.scss']
})
export class FirearmPoolSearchComponent extends FirearmPoolSearchComponentBase {

  displayedColumns: string[] = [ 'firearmAssetId', 'firearm.assetId', 'manager.user', 'businessUnit.buId', 'lockVersion', 'status', 'actions'];
  disabledColumns: string[] = [ 'firearmAssetId', 'lockVersion'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmPoolService: FirearmPoolService,
    protected firearmService: FirearmService,
    protected managerService: AssetsUserDetailsService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmPoolService, firearmService, managerService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    this.firearmLoadSelectionList();
    this.managerLoadSelectionList();
    
    if (this.restoreFormFromParams(this.searchForm)) {
      this.disableFormControlsFromParams(this.searchForm);
    } else {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
    
    super.onInitAsyncComplete();
  }
  
  resetSearchForm() {
    // placeholder
  }
  
  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }
  

  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
}



